export const TermsConditions ={
  "jcr:primaryType": "cq:PageContent",
  "jcr:createdBy": "admin",
  "title": "terms-and-conditions",
  "cq:template": "/apps/gdocs/templates/page-create-case",
  "jcr:language": "en",
  "cq:contextHubSegmentsPath": "/etc/segmentation/contexthub",
  "jcr:created": "Wed May 09 2018 11:22:21 GMT+0000",
  "cq:lastModified": "Wed Oct 25 2017 14:28:20 GMT+0000",
  "cq:cloudserviceconfigs": [
    "[]"
  ],
  "sling:resourceType": "gdocs/components/pages/create-case",
  "cq:contextHubPath": "/etc/cloudsettings/default/contexthub",
  "cq:lastModifiedBy": "admin",
  "par": {
    "jcr:primaryType": "nt:unstructured",
    "sling:resourceType": "wcm/foundation/components/parsys",
    "page_title_mainTitle": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "pageHeading": "Terms & Conditions",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "descriptionText": "'By clicking on the Log on button below, you agree to the Legal information, Cookie policy and Privacy Statement (links below). You also confirm that you are authorised by the legal entity or party you represent to access this site and to provide the information and documentation necessary to open a business account and/or access related services on their behalf.'",
      "sling:resourceType": "gdocs/components/content/page_title"
    },
    "button_close": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "buttonLabelClose": "close",
      "sling:resourceType": "gdocs/components/content/button"
    },
    "button_ok": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "buttonLabels": "OK",
      "sling:resourceType": "gdocs/components/content/button"
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Login/json_terms-and-conditions.js